export default __webpack_public_path__ + "static/media/ico-mongodb-score-high.319469c3.svg";